/**
 * The SDP for the remote end of the connection.
 * @method getRemoteDescription
 */
export default function getRemoteDescription () {
  const { nativePeer, log } = this
  log.info('Getting remote description.')

  const remoteDesc = nativePeer.remoteDescription
  /*
   * Ensure it is a RTCSessionDescription object.
   * In some scenarios (based on browser?), it may return an empty object
   *    instead of undefined when there is no local description.
   * TODO: Determine if this is still needed, or if we can use the native
   *    property directly.
   */
  if (remoteDesc && remoteDesc.sdp && remoteDesc.type) {
    return remoteDesc
  } else {
    return undefined
  }
}
